import { render, staticRenderFns } from "./OtherPersons.vue?vue&type=template&id=58ccf473"
import script from "./OtherPersons.vue?vue&type=script&lang=ts"
export * from "./OtherPersons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports